import UserService from "../services/UserService";

const Welcome = () => (
  <div className="jumbotron">
    <div className="flexDirection" style={{alignItems:'center'}}>
    <img src={"MK-Vision-logo.png" } style={{maxWidth:185, maxHeight:73}} alt=""/>
    <h3 style={{marginLeft: 20}}>Công ty Cổ phần MK Vision</h3>
    </div>
    <p className="lead" style={{marginTop: 10, fontSize: 18}}><i>Vui lòng thực hiện đăng nhập!</i></p>
    <div style={{marginTop: 30, display:'flex', justifyContent:'center', alignItems:'center'}}>
    <button className="btn btn-lg btn-warning" onClick={() => UserService.doLogin()}>Đăng nhập</button>
    </div>
  </div>
)

export default Welcome
